import { useAuth0 } from "@auth0/auth0-react";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog/index";
import NewDialog from "components/NewDialog/Dialog";
import { useFormik } from "formik";
import AuthService from "Lib/API/Auth/index";
import FinanceService from "Lib/API/Finance/index";
import React, { useContext, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { BeatLoader } from 'react-spinners';
import { appContext } from "Router/routes";
import { MergeAccountsDetails } from "../MemberDetails/MergeAccounts/MergeAccountsDetails";
import { ContentWrapper, Wrapper } from "../MemberDetails/Theme";
import AccountListViewTable from "./AccountListViewTable";


const AccountListView = ({
  loading,
  list = [],
  perPage = 30,
  totalCount = 0,
  page = 1,
  setPage,
  setRefresh,
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const { setTypeUser } = useContext(appContext);

  const [openAlert, setOpenAlert] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState({});
  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [loadingMerge, setLoadingMerge] = useState(false)
  const [value, setValue] = useState('')
  const [confirmClose, setConfirmClose] = useState(false);


  const mergeFormik = useFormik({
    enableReinitialize: true,
    initialValues: { account: {} },
    validationSchema: "",
  });

  const handleDelete = async () => {
    const token = await getAccessTokenSilently();
    await AuthService.deleteAccount({ accountID: selectedAccount?.accountId }, token)
      .then((res) => {
        if (res) {
          setOpenAlert(false);
          setRefresh((prev) => !prev);
          toastr.success("Success", "Account deleted successfully");
        }
      })
      .catch((err) => {
        setOpenAlert(false);
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
  };

  const handleMergeApi = async () => {
    const token = await getAccessTokenSilently();
    console.log("account", mergeFormik.values);
    const data = {
      accountId: mergeFormik.values.account?.accounts?._id,
      mergeToAccountId: selectedAccount?.accountId
    }
    if (token) {
      setLoadingMerge(true)
      await FinanceService.MergeAccount(data, token)
        .then((res) => {
          handleMergeButton()
          toastr.success("Success", "Merged Account successfully");
        })
        .catch((err) => {
          toastr.error(
            "error",
            err?.data?.message || "Merged Account Failed"
          );
        }).finally(() => { setLoadingMerge(false) });
    }
  }

  const handleMergeButton = () => {
    setIsOpenMergePopUp(!isOpenMergePopUp)
    mergeFormik.setFieldValue('account', {});
    mergeFormik.setFieldValue('error', false);
    setValue('')
  }

  const onMergeClick = (row) => {
    setIsOpenMergePopUp((prev) => !prev);
    setSelectedAccount(row);
  }



  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    handleMergeButton()
  }

  return (
    <div className="w-100 school_class_list">
      
      <AccountListViewTable 
        list={list}
        loading={loading}
        perPage={perPage}
        page={page}
        totalCount={totalCount}
        setPage={setPage}
        onMergeClick={onMergeClick}
        setTypeUser={setTypeUser}
        setSelectedAccount={setSelectedAccount}
        setOpenAlert={setOpenAlert}

      />

      {selectedAccount?.accountId &&
        <NewDialog isOpen={isOpenMergePopUp} handleClose={closeModal}
          loading={loadingMerge}
          title={"Merge Accounts"}
          sx={{ '& .MuiDialog-paperWidthSm': { minWidth: "997.01px", height: "97%" } }}
          content={<ContentWrapper>
            <MergeAccountsDetails account={selectedAccount} formik={mergeFormik} value={value} setValue={setValue} />
            <Wrapper>
              <Button
                onClick={closeModal}
                variant="primary-outline"
                size="md"
                style={{ minWidth: "100px" }}
              >
                <span>Cancel</span>
              </Button>
              <Button
                onClick={handleMergeApi}
                variant="primary"
                size="md"
                style={{ minWidth: "100px" }}
                disabled={loadingMerge || !value.toLowerCase().includes('merge')}
              >
                {loadingMerge ? (
                  <BeatLoader color="#fff" size={6} margin={1} />
                ) : <span>Merge</span>}
              </Button>
            </Wrapper>
          </ContentWrapper>}
          contentStyle={{ display: 'flex', justifyContent: 'center', height: '100%' }}
          buttonStyle={{ justifyContent: 'right' }}
        >
        </NewDialog>

      }
      <AlertDialog
        open={openAlert}
        onDecline={() => setOpenAlert(false)}
        onAccept={() => handleDelete()}
        title={`Are you sure?`}
        description={`Do you want to delete this account?`}
      />
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  )
}

export default AccountListView